"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedCollections = exports.getFollowedFormattedCollections = exports.getMyFormattedCollection = void 0;

var _values = _interopRequireDefault(require("lodash/values"));

var _get = _interopRequireDefault(require("lodash/get"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getCollectionImageUrl = function _getCollectionImageUrl(collection) {
  var imageUrl;
  imageUrl = (0, _get.default)(collection, ['image', 'url']);

  if ('imageLarge' in collection) {
    imageUrl = (0, _get.default)(collection, ['imageLarge', 'url']);
  }

  return imageUrl;
};

var getCollections = function getCollections(_ref) {
  var collections = _ref.collections;
  return collections;
};

var getCollectionEntities = function getCollectionEntities(_ref2) {
  var entities = _ref2.entities;
  return (0, _values.default)(entities).reverse();
};

var getMyCollections = function getMyCollections(collections) {
  return collections.filter(function (_ref3) {
    var canEdit = _ref3.canEdit;
    return canEdit;
  });
};

var getFollowedCollections = function getFollowedCollections(collections) {
  return collections.filter(function (_ref4) {
    var _ref4$followStatus = _ref4.followStatus,
        followStatus = _ref4$followStatus === void 0 ? {} : _ref4$followStatus;
    return !!followStatus.followedByYou;
  });
};

var formatCollections = function formatCollections(collections) {
  return collections.map(function () {
    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      name: collection.name,
      eventCount: collection.eventCount,
      id: collection.id,
      href: "/c/".concat(collection.id),
      imageUrl: _getCollectionImageUrl(collection),
      followedByYou: (0, _get.default)(collection, ['followStatus', 'followedByYou'], false)
    };
  });
};

var getMyFormattedCollection = function getMyFormattedCollection(state) {
  return (0, _utils.createSelector)(getCollections, getCollectionEntities, getMyCollections, formatCollections)(state);
};

exports.getMyFormattedCollection = getMyFormattedCollection;

var getFollowedFormattedCollections = function getFollowedFormattedCollections(state) {
  return (0, _utils.createSelector)(getCollections, getCollectionEntities, getFollowedCollections, formatCollections)(state);
};

exports.getFollowedFormattedCollections = getFollowedFormattedCollections;

var getFormattedCollections = function getFormattedCollections(state) {
  return (0, _utils.createSelector)(getCollections, getCollectionEntities, formatCollections)(state);
};

exports.getFormattedCollections = getFormattedCollections;
//# sourceMappingURL=selectors.js.map